import { ScreeningCheckOutcome, ScreeningCheckType, ScreeningState } from '../../interfaces/screening.interface';

export const CHECK_TYPE_LABELS: Record<ScreeningCheckType, string> = {
  expiry: 'Expiry',
  date_coherence: 'Date Coherence',
  dates_match: 'Dates Match',
  standard_version: 'Standard Version',
  company_name: 'Company Name',
  site_match: 'Site Match',
  application_match: 'Application Match',
  activity_scope: 'Activity Scope',
  cb_recognized: 'CB Recognized',
  accreditor_pairing: 'Accreditor Pairing',
  document_type: 'Document Type',
};

export const CHECK_OUTCOME_LABELS: Record<ScreeningCheckOutcome, string> = {
  pass: 'Pass',
  flag: 'Flag',
  not_evaluated: 'Not Evaluated',
  not_applicable: 'Not Applicable',
};

export const ADMIN_RESPONSE_LABELS: Record<string, string> = {
  unset: 'Unreviewed',
  accepted: 'Accepted',
  dismissed: 'Dismissed',
};

export const SCREENING_STATE_LABELS: Record<ScreeningState, string> = {
  not_screened: 'Not Screened',
  failed: 'Did Not Finish',
  needs_review: 'Needs Review',
  reviewed: 'Flags Reviewed',
  not_evaluated: 'Not Evaluated',
  nothing_checked: 'Nothing To Check',
  clean: 'Clean',
};

export const SCREENING_STATE_OPTIONS = Object.entries(SCREENING_STATE_LABELS)
  .map(([value, label]) => ({ value, label }));

export const CHECK_TYPE_OPTIONS = Object.entries(CHECK_TYPE_LABELS).map(([value, label]) => ({ value, label }));
export const CHECK_OUTCOME_OPTIONS = Object.entries(CHECK_OUTCOME_LABELS).map(([value, label]) => ({ value, label }));
export const ADMIN_RESPONSE_OPTIONS = Object.entries(ADMIN_RESPONSE_LABELS).map(([value, label]) => ({ value, label }));
